import { render } from "./code_join_team.vue?vue&type=template&id=05fdf3ae&scoped=true"
import script from "./code_join_team.vue?vue&type=script&lang=js"
export * from "./code_join_team.vue?vue&type=script&lang=js"

import "./code_join_team.vue?vue&type=style&index=0&id=05fdf3ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05fdf3ae"],['__file',"src/views/user_center/components/code_join_team.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05fdf3ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05fdf3ae', __exports__)) {
    api.reload('05fdf3ae', __exports__)
  }
  
  module.hot.accept("./code_join_team.vue?vue&type=template&id=05fdf3ae&scoped=true", () => {
    api.rerender('05fdf3ae', render)
  })

}


export default __exports__